import { default as NextImage } from "next/image";

export default function Figure(props: {
  className?: string;
  height: number;
  image: { alt?: string; filename: string; focus?: string };
  priority?: boolean;
  sizes?: string;
  width: number;
}) {
  const pixelDensity = 3;
  return (
    <NextImage
      alt={props.image.alt ? props.image.alt : ""}
      className={props.className ? props.className : ""}
      height={props.height}
      src={
        props.image.focus
          ? `${props.image.filename}/m/${props.width * pixelDensity}x${
              props.height * pixelDensity
            }/smart/filters:quality(100)focal(${props.image.focus})`
          : `${props.image.filename}/m/${props.width * pixelDensity}x${
              props.height * pixelDensity
            }/smart/filters:quality(100)`
      }
      priority={props.priority ? props.priority : false}
      sizes={props.sizes}
      width={props.width}
    />
  );
}
